import { TextField } from '@mui/material';
import { useMemo } from 'react';

export default function AddressForm({
  isEditing,
  updatedDetails,
  setUpdatedDetails,
  error,
  setError,
}: {
  isEditing: boolean;
  updatedDetails: any;
  setUpdatedDetails: any;
  error: { [key: string]: string };
  setError: any;
}) {
  const EditInput = useMemo(() => {
    return ({
      label,
      value,
      setValue,
      disabled,
      required,
    }: {
      label: string;
      value: string;
      setValue: any;
      disabled?: boolean;
      required?: boolean;
    }) => {
      return (
        <TextField
          required={required}
          disabled={!isEditing || disabled}
          label={label}
          variant="outlined"
          value={value}
          onBlur={(e) =>
            required &&
            (value.length === 0
              ? setError({ ...error, [label]: 'This field is required' })
              : setError({ ...error, [label]: '' }))
          }
          onChange={(e) => {
            setValue(e.target.value);
          }}
          sx={{
            width: '100%',
            '& .MuiInputBase-input.Mui-disabled': {
              color: '#000',
              WebkitTextFillColor: '#000000',
            },
          }}
          size="small"
          error={!!error[label]}
          helperText={error[label]}
        />
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditing, error]);

  return (
    <>
      <EditInput
        label="House No"
        required
        value={updatedDetails?.house_no ?? ''}
        setValue={(v: string) => setUpdatedDetails({ ...updatedDetails, house_no: v })}
      />
      <EditInput
        required
        label="Address Line 1"
        value={updatedDetails?.line1 ?? ''}
        setValue={(v: string) => setUpdatedDetails({ ...updatedDetails, line1: v })}
      />
      <EditInput
        label="Address Line 2"
        value={updatedDetails?.line2 ?? ''}
        setValue={(v: string) => setUpdatedDetails({ ...updatedDetails, line2: v })}
      />
      <EditInput
        label="Address Line 3"
        value={updatedDetails?.line3 ?? ''}
        setValue={(v: string) => setUpdatedDetails({ ...updatedDetails, line3: v })}
      />
      <EditInput
        label="Street / Area"
        disabled
        value={updatedDetails?.street ?? ''}
        setValue={(v: string) => setUpdatedDetails({ ...updatedDetails, street: v })}
      />
      <EditInput
        label="City"
        disabled
        value={updatedDetails?.city ?? ''}
        setValue={(v: string) => setUpdatedDetails({ ...updatedDetails, city: v })}
      />
      <EditInput
        label="State"
        disabled
        value={updatedDetails?.state ?? ''}
        setValue={(v: string) => setUpdatedDetails({ ...updatedDetails, state: v })}
      />
      <EditInput
        label="Zip Code"
        disabled
        value={updatedDetails?.zipcode ?? ''}
        setValue={(v: string) => setUpdatedDetails({ ...updatedDetails, zipcode: v })}
      />
    </>
  );
}
